import { ADMIN_COLORS } from '@/features/admin/utils/adminAnimations';

export function CardSkeleton() {
  return (
    <div
      className="flex items-center justify-between w-full py-3 px-3 md:py-3.5 md:px-4 rounded-xl animate-pulse"
      style={{
        backgroundColor: ADMIN_COLORS.surface,
        border: `1px solid ${ADMIN_COLORS.border}`,
        boxShadow: ADMIN_COLORS.shadow,
        opacity: 0.6,
      }}
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div
          className="w-10 h-10 md:w-12 md:h-12 rounded-full flex-shrink-0"
          style={{ backgroundColor: ADMIN_COLORS.surface, border: `1px solid ${ADMIN_COLORS.border}` }}
        />
        <div className="flex-1 min-w-0 space-y-2">
          <div className="h-4 rounded w-32" style={{ backgroundColor: ADMIN_COLORS.surface }} />
          <div className="h-3 rounded w-48" style={{ backgroundColor: ADMIN_COLORS.surface, opacity: 0.6 }} />
        </div>
      </div>
    </div>
  );
}
